import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showToast, showLoadingToast, showFailToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const news = ref({});
    const content = ref("");
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      let newsId = router.currentRoute.value.query.id;
      if (newsId > 0) {
        showLoadingToast({
          message: '加载中',
          forbidClick: true
        });
        httpRequest({
          method: "get",
          url: "?file=news&act=show&id=" + newsId
        }).then(res => {
          closeToast();
          if (res.state == 1) {
            news.value = res.info;
          } else {
            showFailToast(res.msg);
          }
        });
      } else {
        showToast({
          message: "参数错误",
          onClose: function () {
            router.go(-1);
          }
        });
      }
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      news,
      content,
      goBack
    };
  }
};